import windowEvents from './windowEvents';

export default () => {
    return Object.entries(windowEvents(global.window)).map(keyValue => store => next => action => keyValue[1](store, next, action));
}



// WEBPACK FOOTER //
// ./modules/Common/middleware/windowEventsFactory.js